import VenueChannelsFields from './VenueChannelsFields';
export default VenueChannelsFields;
